import { makeStyles } from '@mui/styles';

const useInterviewQuestionContentStyle = makeStyles(() => ({
  container: {
    paddingTop: '32px',
  },
}));

export default useInterviewQuestionContentStyle;
